import type { LucideIcon } from 'lucide-react';
import { Icon } from '../icons';
import { Badge as BadgePrimitive } from '../primitives/badge';

type Tone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

// Each tone is its role colour on the role's tint, the declared contrast pairs (design system §3.1).
const tones: Record<Tone, string> = {
  neutral: 'bg-surface-muted text-text',
  info: 'bg-info-muted text-info',
  success: 'bg-success-muted text-success',
  warning: 'bg-warning-muted text-warning',
  danger: 'bg-danger-muted text-danger',
};

type BadgeProps = { children: string; tone?: Tone; icon?: LucideIcon };

export function Badge({ children, tone = 'neutral', icon }: BadgeProps) {
  return (
    <BadgePrimitive className={tones[tone]}>
      {icon && <Icon icon={icon} size="sm" />}
      {children}
    </BadgePrimitive>
  );
}
